import Vue from 'vue'
import template from './lottie.vue'


const LottieConstructor = Vue.extend(template)

let lottieInstance = null
let lastConstructor = null
let lastOptions = null

//options 必須包括 giftId 和 basePath
const Lottie = (options = null) => {
    let Handler = LottieConstructor

    if (!lottieInstance || lastConstructor !== Handler || lastOptions && lastOptions.chatAvatar || lastOptions && lastOptions.isSix) {
      lottieInstance = new Handler({
        el: document.createElement('div')
      })
    }

    lastConstructor = Handler
    lastOptions = options
    Object.assign(lottieInstance.$data, options || {}, {
      visible: true
    })

    return new Promise(resolve => {
      lottieInstance.success = () => {
        resolve()
      }

      document.body.appendChild(lottieInstance.$el)
    })
}

export default Lottie
